export default __webpack_public_path__ + "static/static_chart-14bd0a8d65f0b105502bfa35658d32c1.png";